/**
 * Deposit Method View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseView = require('common/base.view');
    var cashierUtil = require('modules/cashier/cashier.util');
    var Form = require('class/form.class');
    var core = require('core');
    var postMessageManager = require('managers/postMessage.manager.instance');

    module.exports = BaseView.extend({

        events: {
            'click .fn-wirecard-finalize': 'finalizeWireCard',
            'click .fn-wirecard-cancel': 'cancelWireCard'
        },

        template: 'wirecard-deposit.method',

        initialize: function(options) {
            this.options = options;

            BaseView.prototype.initialize.apply(this, arguments);

            core.on('server:message', this._handleWireCardPush.bind(this));
        },

        remove: function() {
            this.destroyPostMessages();

            BaseView.prototype.remove.apply(this, arguments);
        },

        initPostMessages: function() {
            this.destroyPostMessages();

            this.postMessageHandlerId = postMessageManager.addHandler({
                source: this.$('iframe')[0].contentWindow,
                callback: this._handlePostMessage.bind(this),
                parse: true
            });
        },

        destroyPostMessages: function() {
            if (!this.postMessageHandlerId) {
                return;
            }

            postMessageManager.removeHandler(this.postMessageHandlerId);
        },

        render: function() {
            BaseView.prototype.render.apply(this, arguments);

            this.$el.html(this.tmpl(this.template, {
                amount: this.options.data.amount
            }));

            this.form = new Form(this.$('form'));

            return this;
        },

        initializeWireCard: function(paymentURL) {
            if (!window.WPP) {
                core.error('Please include WireCard JS file');
                return;
            }

            window.WPP.seamlessRender({
                url: paymentURL,
                wrappingDivId: 'wirecard-seamless-form-target',
                onSuccess: function() {
                    this.hideWirecardLoader();
                    this.initPostMessages();
                }.bind(this),
                onError: function() {
                    this.hideWirecardLoader();
                    this.options.onClose();
                    cashierUtil.notifyTransactionStatus('action=deposit&status=error&initiator=cashier_backbone');
                }.bind(this)
            });
        },

        hideWirecardLoader: function() {
            this.$el.find('.fn-wirecard-loader').addClass('hidden');
        },

        finalizeWireCard: function() {
            this.form.showLoading();

            window.WPP.seamlessSubmit({
                onSuccess: function() {
                    this.form.hideLoading();
                    this.options.onClose(true);
                }.bind(this),
                onError: function() {
                    this.form.hideLoading();
                }.bind(this)
            });
        },

        cancelWireCard: function() {
            this.options.onClose();
            cashierUtil.notifyTransactionStatus('action=deposit&status=cancel&initiator=cashier_backbone');
        },

        _handlePostMessage: function(data) {
            switch (data.type) {
                case 'wdPostMessage_integratedPaymentPageRenderNotify':

                    if (data.payload.height) {
                        this.$('#wirecard-seamless-form-target').css('height', data.payload.height);
                    }

                    break;
            }
        },

        _handleWireCardPush: function(message) {
            if(message.ID !== 31133) {
                return;
            }

            var msgInfo = message.data.action.showMessageNotificationInfo;
            var hasMessage = msgInfo && msgInfo.message;

            if(hasMessage) {
                this.options.onClose();
            }
        }
    });
});
